import React, { createContext, useState, ReactNode } from 'react';

export interface AuthContextProps {
  token: string;
  setToken: (token: string) => void;
  isAdmin: boolean;
  setIsAdmin: (isAdmin: boolean) => void;
}

const INVALID_TOKEN = 'invalid_token';

const initialAuthContext: AuthContextProps = {
  token: INVALID_TOKEN,
  setToken: () => {
    return;
  },
  isAdmin: false,
  setIsAdmin: () => {
    return;
  },
};

initialAuthContext.setToken('');

export const AuthContext = createContext<AuthContextProps>(initialAuthContext);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string>(initialAuthContext.token);
  const [isAdmin, setIsAdmin] = useState<boolean>(initialAuthContext.isAdmin);

  return (
    <AuthContext.Provider value={{ token, setToken, isAdmin, setIsAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};
